"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const allRuleNodes = [
    {
        $ref: '#/definitions/IListNode',
    },
    {
        $ref: '#/definitions/IPercentageNode',
    },
    {
        $ref: '#/definitions/IMultivariateNode',
    },
];
const allLeafNodes = [
    {
        $ref: '#/definitions/BooleanValueNode',
    },
    {
        $ref: '#/definitions/FloatValueNode',
    },
    {
        $ref: '#/definitions/IntValueNode',
    },
    {
        $ref: '#/definitions/JsonValueNode',
    },
    {
        $ref: '#/definitions/StringValueNode',
    },
];
const allNodes = [...allRuleNodes, ...allLeafNodes];
exports.default = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    definitions: {
        DynamicValueType: {
            enum: ['experiment', 'rollout', 'operational', 'custom'],
            type: 'string',
        },
        BooleanValueNode: {
            additionalProperties: false,
            properties: {
                nodeType: {
                    enum: ['value'],
                    type: 'string',
                },
                returnType: {
                    enum: ['boolean'],
                    type: 'string',
                },
                value: {
                    type: 'boolean',
                },
                tag: {
                    type: 'string',
                },
            },
            required: ['nodeType', 'returnType', 'value'],
            type: 'object',
        },
        ErrorMode: {
            enum: ['log_all', 'reduced', 'silent'],
            type: 'string',
        },
        FloatValueNode: {
            additionalProperties: false,
            properties: {
                nodeType: {
                    enum: ['value'],
                    type: 'string',
                },
                returnType: {
                    enum: ['float'],
                    type: 'string',
                },
                value: {
                    type: 'number',
                },
                tag: {
                    type: 'string',
                },
            },
            required: ['nodeType', 'returnType', 'value'],
            type: 'object',
        },
        IListNode: {
            additionalProperties: false,
            properties: {
                children: {
                    items: {
                        anyOf: allNodes,
                    },
                    type: 'array',
                },
                list: {
                    items: {},
                    type: 'array',
                },
                nodeType: {
                    enum: ['allowlist', 'blacklist', 'denylist', 'whitelist'],
                    type: 'string',
                },
                target: {
                    type: 'string',
                },
            },
            required: ['children', 'list', 'nodeType', 'target'],
            type: 'object',
        },
        IPercentageNode: {
            additionalProperties: false,
            properties: {
                bucketKey: {
                    type: 'string',
                },
                children: {
                    items: {
                        anyOf: allNodes,
                    },
                    type: 'array',
                },
                nodeType: {
                    enum: ['percentage'],
                    type: 'string',
                },
                percent: {
                    type: 'number',
                },
            },
            required: ['bucketKey', 'children', 'nodeType', 'percent'],
            type: 'object',
        },
        IMultivariateNode: {
            additionalProperties: false,
            properties: {
                bucketKey: {
                    type: 'string',
                },
                children: {
                    items: {
                        anyOf: allNodes,
                    },
                    type: 'array',
                },
                nodeType: {
                    enum: ['multivariate'],
                    type: 'string',
                },
                buckets: {
                    items: {
                        type: 'integer',
                    },
                    type: 'array',
                },
            },
            required: ['bucketKey', 'children', 'nodeType', 'buckets'],
            type: 'object',
        },
        IntValueNode: {
            additionalProperties: false,
            properties: {
                nodeType: {
                    enum: ['value'],
                    type: 'string',
                },
                returnType: {
                    enum: ['int'],
                    type: 'string',
                },
                value: {
                    type: 'number',
                },
                tag: {
                    type: 'string',
                },
            },
            required: ['nodeType', 'returnType', 'value'],
            type: 'object',
        },
        JsonValueNode: {
            additionalProperties: false,
            properties: {
                nodeType: {
                    enum: ['value'],
                    type: 'string',
                },
                returnType: {
                    enum: ['json'],
                    type: 'string',
                },
                value: {
                    additionalProperties: {},
                    type: 'object',
                },
                tag: {
                    type: 'string',
                },
            },
            required: ['nodeType', 'returnType', 'value'],
            type: 'object',
        },
        StringValueNode: {
            additionalProperties: false,
            properties: {
                nodeType: {
                    enum: ['value'],
                    type: 'string',
                },
                returnType: {
                    enum: ['string'],
                    type: 'string',
                },
                value: {
                    type: 'string',
                },
                tag: {
                    type: 'string',
                },
            },
            required: ['nodeType', 'returnType', 'value'],
            type: 'object',
        },
        TrackingMode: {
            enum: ['debug', 'experiment', 'silent'],
            type: 'string',
        },
    },
    properties: {
        dvType: {
            $ref: '#/definitions/DynamicValueType',
        },
        children: {
            items: {
                anyOf: allRuleNodes,
            },
            type: 'array',
        },
        createdAt: {
            type: 'string',
        },
        default: {
            anyOf: allLeafNodes,
        },
        errorMode: {
            $ref: '#/definitions/ErrorMode',
        },
        lastEdited: {
            type: 'string',
        },
        lastEditor: {
            type: 'string',
        },
        nodeType: {
            enum: ['meta'],
            type: 'string',
        },
        schemaVersion: {
            type: 'string',
        },
        trackingIdentifier: {
            type: 'string',
        },
        bucketingMethod: {
            type: 'string',
        },
        trackingMode: {
            $ref: '#/definitions/TrackingMode',
        },
        version: {
            type: 'number',
        },
        revisionNumber: {
            type: 'number',
        },
    },
    required: [
        'children',
        'createdAt',
        'default',
        'errorMode',
        'lastEdited',
        'lastEditor',
        'nodeType',
        'schemaVersion',
        'trackingIdentifier',
        'trackingMode',
    ],
    type: 'object',
};
//# sourceMappingURL=schema.js.map